/* eslint-disable */
import React, { useState, useContext } from 'react';
import { FaAngleRight } from 'react-icons/fa';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, Card } from 'react-bootstrap';

import { Context } from 'context/AuthContext';
import { getStringFromDate } from '../_constants';
import './styles.scss';

function Resumo(props) {
  const { model, enviarSolicitacao } = props;
  const [ico, setIcon] = useState(false);

  const mudarIcon = () => {
    if (ico === false) {
      setIcon(true);
    } else {
      setIcon(false);
    }
  };

  const resumoItem = (item, model) => {
    return (
      <div className="col-lg-12 resumo mb-4" key={item.materialComunicacaoId}>
        <div className="resumo-header">
          <Accordion.Toggle
            onClick={mudarIcon}
            as={Card.Header}
            eventKey={item.materialComunicacaoId}
          >
            {item.materialComunicacao.nome}
            <div className="float-right">
              <FontAwesomeIcon
                id="icone"
                icon={ico !== true ? faAngleDown : faAngleUp}
              ></FontAwesomeIcon>
            </div>
          </Accordion.Toggle>
        </div>
        <Accordion.Collapse eventKey={item.materialComunicacaoId}>
          <div className="resumo-body">
            <div className="resumo-informacoes">
              <h4>Informações</h4>
              <table className="table table-striped">
                <tbody>
                  <tr>
                    <th>Solicitante</th>
                    <td>{model?.solicitante?.nome}</td>
                  </tr>
                  <tr>
                    <th>Supervisor</th>
                    <td>{model?.usuarioSuperior?.nome}</td>
                  </tr>
                  <tr>
                    <th>Regional</th>
                    <td>{model.loja?.regional?.nome}</td>
                  </tr>
                  <tr>
                    <th>Cliente</th>
                    <td>{model.loja?.razaoSocial}</td>
                  </tr>
                  <tr>
                    <th>CNPJ</th>
                    <td>{model.loja?.cnpj}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="resumo-informacoes">
              <h4>Layout</h4>
              <img
                src={model?.layoutArteFacil?.urlImagem}
                className="img-fluid"
              />
              <hr />
            </div>
            <div className="resumo-informacoes">
              <h4>Ação Promocional</h4>
              <table className="table table-striped">
                <tbody>
                  <tr>
                    <th>Início da Vigência</th>
                    <td>
                      {getStringFromDate(
                        item.solicitacaoDados?.dataVeiculacaoInicio
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Fim da Vigência</th>
                    <td>
                      {getStringFromDate(
                        item?.solicitacaoDados?.dataVeiculacaoFim
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Incluir logo?</th>
                    <td>{item.solicitacaoDados?.possuiLogo ? 'Sim' : 'Não'}</td>
                  </tr>
                  <tr>
                    <th>Tamanhos</th>
                    <td>
                      {item.solicitacaoTamanhos.map(
                        (tamanho) => `${tamanho.largura}x${tamanho.altura} `
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Observação</th>
                    <td style={{ whiteSpace: 'break-spaces' }}>
                      {item.solicitacaoDados?.observacoesGerais}
                    </td>
                  </tr>
                  <tr>
                    <th>Incluir Ação Promocional?</th>
                    <td>
                      {item.solicitacaoDados.possuiAcaoPromocional
                        ? 'Sim'
                        : 'Não'}
                    </td>
                  </tr>

                  {item.solicitacaoAcaoPromocionais !== null &&
                    item.solicitacaoAcaoPromocionais.length > 0 &&
                    item.solicitacaoDados.possuiAcaoPromocional &&
                    item.solicitacaoAcaoPromocionais.map(
                      (acao, key) =>
                        acao.acaoPromocional?.texto && (
                          <tr key={key}>
                            <th></th>
                            <td>
                              {acao.acaoPromocional?.texto}
                              {'  '}
                              {acao.solicitacaoAcaoPromocionalValores &&
                                acao.solicitacaoAcaoPromocionalValores.length &&
                                acao.solicitacaoAcaoPromocionalValores.map(
                                  (valor) =>
                                    `${valor.acaoPromocionalCampo.texto}: ${
                                      valor.valor && valor.valor
                                    } `
                                )}
                            </td>
                          </tr>
                        )
                    )}
                </tbody>
              </table>
            </div>
            <div className="resumo-informacoes">
              <h4>Dados de Envio</h4>
              <table className="table table-striped">
                <tbody>
                  <tr>
                    <th>Nome</th>
                    <td>{item.solicitacaoEntregaDigital?.nomeResponsavel}</td>
                  </tr>
                  <tr>
                    <th>Telefone</th>
                    <td>
                      {item.solicitacaoEntregaDigital?.telefoneResponsavel}
                    </td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{item.solicitacaoEntregaDigital?.emailResponsavel}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Accordion.Collapse>
      </div>
    );
  };

  return (
    <div className="container mt-5 content-pedido-resumo">
      <div className="row">
        <div className="col-lg-12">
          <Accordion>
            {model.solicitacoes &&
              model.solicitacoes.map((item) => resumoItem(item, model))}
          </Accordion>
        </div>
      </div>

      <div className="d-flex align-items-end flex-column mt-5">
        <button
          className={`btn btn-primary btn-navigation btn-navigation-right`}
          onClick={() => {
            enviarSolicitacao();
          }}
        >
          <span>FINALIZAR PEDIDO</span>
          <span>
            <FaAngleRight size={26} />
          </span>
        </button>
      </div>
    </div>
  );
}

export default Resumo;
